import React from "react";
import "./sidebar.scss";
interface SideBarProps {
	items: string[];
	selectedItem: string | null;
	onSelect: (item: string) => void;
}

const SideBar: React.FC<SideBarProps> = ({ items, selectedItem, onSelect }) => {
	return (
		<div className="sidebar">
            <p>Widgets</p>
			<ul>
				{items.map((item) => (
					<li
						key={item}
						className={selectedItem === item ? "selected" : ""}
						onClick={() => onSelect(item)}
					>
						{item}
					</li>
				))}
			</ul>
		</div>
	);
};

export default SideBar;
